// Auto generated file, do not manually modify!
// com.hotpads.capps.client.enums.applicationconfiguration.ApplicationConfigurationRequiredDocumentType

export enum ApplicationConfigurationRequiredDocumentType {
  BANK_STATEMENTS = 'BANK_STATEMENTS',
  CPA_ATTESTATION = 'CPA_ATTESTATION',
  EMPLOYMENT_VERIFICATION_LETTER = 'EMPLOYMENT_VERIFICATION_LETTER',
  FORM_1099 = 'FORM_1099',
  PAY_STUBS = 'PAY_STUBS',
  PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT = 'PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT',
  PROOF_OF_OTHER_INCOME = 'PROOF_OF_OTHER_INCOME',
  STATEMENT_OF_ASSETS = 'STATEMENT_OF_ASSETS',
  TAX_RETURNS = 'TAX_RETURNS',
  W2 = 'W2',
}

export const ApplicationConfigurationRequiredDocumentType_values = [
  ApplicationConfigurationRequiredDocumentType.BANK_STATEMENTS,
  ApplicationConfigurationRequiredDocumentType.CPA_ATTESTATION,
  ApplicationConfigurationRequiredDocumentType.EMPLOYMENT_VERIFICATION_LETTER,
  ApplicationConfigurationRequiredDocumentType.FORM_1099,
  ApplicationConfigurationRequiredDocumentType.PAY_STUBS,
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT,
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_OTHER_INCOME,
  ApplicationConfigurationRequiredDocumentType.STATEMENT_OF_ASSETS,
  ApplicationConfigurationRequiredDocumentType.TAX_RETURNS,
  ApplicationConfigurationRequiredDocumentType.W2,
] as const;
